/**
 * Initial contact mutation — just email + privacy acceptance for step 1
 * Uses the same makeContact mutation but with minimal data
 */
import type { MakeContactMutationVariables } from '../gql/graphql'

export { MakeContactDocument } from '../gql/graphql'

export function toInitialContactVariables(
  email: string,
  acceptPrivacyPolicy: boolean,
  acceptMarketing: boolean,
  source?: string,
  utm_source?: string,
  // Reserved for future use (e.g. propertyId in mutation)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  context?: Record<string, unknown>
): MakeContactMutationVariables {
  return {
    data: {
      email,
      acceptPrivacyPolicy,
      acceptMarketing,
      source,
      utm_source,
      personalData: {
        set: {
          email,
        },
      },
      // Note: no property context for initial contact
    },
  }
}
